import React from 'react';
import ReactSlider from 'react-slider';
import './RatingRangeSlider.css';

const RatingRangeSlider = ({ minValue = 0, maxValue = 10, onChange }) => {
  const [value, setValue] = React.useState([minValue, maxValue]);

  const handleChange = (newValue) => {
    setValue(newValue);
    onChange?.({ min: newValue[0], max: newValue[1] });
  };

  return (
    <div className="rating-range-wrapper">
      <ReactSlider
        className="rating-slider"
        thumbClassName="slider-thumb"
        trackClassName="slider-track"
        min={0}
        max={10}
        step={1}
        value={value}
        onChange={handleChange}
        withTracks={true}
        pearling
        minDistance={1}
      />
      <div className="range-values">
        {value[0]} – {value[1]}
      </div>
    </div>
  );
};

export default RatingRangeSlider;
